<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="800" persistent>
      <v-card>
        <v-card-title>
          <span class="headline"
            >Upload
            {{ type == "supporting" ? "Supporting" : "Output" }} Document</span
          >
        </v-card-title>

        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <div id="preview">
                <img v-if="url" :src="url" />
              </div>
            </v-col>
            <v-col cols="10" class="px-10">
              <input
                type="file"
                hidden
                multiple
                ref="attachedFiles"
                v-if="multiFileInputAccess()"
                @change="onMultiFileChange"
              />
              <v-select
                v-if="multiFileInputAccess()"
                v-model="attachedFiles"
                :items="attachedFiles"
                chips
                prepend-icon="attach_file"
                multiple
                @click="$refs.attachedFiles.click()"
                @click:prepend="$refs.attachedFiles.click()"
                label="Files"
                append-icon
              ></v-select>
              <input type="file" @change="onFileChange" v-else />
              <p class="mt-2 mb-n2 ml-16 red--text" v-if="no_file_error">
                <v-icon class="red--text">mdi-alert-outline</v-icon>
                No file attached
              </p>
            </v-col>
            <v-col cols="10" class="pl-10" v-show="type == 'supporting'">
              <v-text-field
                label="Add Remarks (optional)"
                v-model="remarks"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              class="mb-n4"
              style="margin-top: -70px"
              v-if="upload_loader"
            >
              <v-text-field
                color="success"
                loading
                disabled
                style="width: 83%; padding-left: 33px"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="errorMessage">
              <h3 class="text-center red--text">{{ errorMessage }}</h3>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text color="indigo" @click="saveOutputDocument()"
            >Upload</v-btn
          >
          <v-btn text color="grey" @click="close()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import Swal from "sweetalert2";
  import axios from "axios";
  import { fileSystemUrl } from "../../config/config.json";

  export default {
    props: {
      dialog: Boolean,
      routeId: Number,
      document: Object,
      type: String,
      routeType: String,
      subRouteIndex: Number,
      parentRouteId: String,
    },
    name: "UploadOutputDocumentModal",
    data() {
      return {
        url: null,
        no_file_error: false,
        upload_loader: false,
        errorMessage: null,
        file: null,
        filepath_url: null,
        date_uploaded: null,
        user_uploaded: null,
        remarks: "",
        multiFileUploadRoleAccess: [
          "Records Officer",
          "Regional Director",
          "Admin",
        ],
        attachedFiles: [],
        uploadedAttachedFiles: [],
      };
    },
    methods: {
      ...mapActions([
        "addSubrouteOutputDocument",
        "addSubrouteSupportingDocument",
        "addChildSubrouteOutputDocument",
        "addInitiatorSupportingDocument",
        "addChildSubrouteSupportingDocument",
      ]),
      onFileChange(e) {
        const file = e.target.files[0];
        this.url = URL.createObjectURL(file);
        this.file = file;
      },
      onMultiFileChange() {
        this.attachedFiles = [];
        for (let i = 0; i < this.$refs.attachedFiles.files.length; i++)
          this.attachedFiles.push(this.$refs.attachedFiles.files[i].name);
      },
      async uploadDocument() {
        this.upload_loader = false;
        this.no_file_error = false;
        this.upload_loader = true;

        if (this.file || this.attachedFiles.length > 0) {
          const formData = new FormData();
          if (this.multiFileInputAccess()) {
            this.$refs.attachedFiles.files.forEach(file => {
              formData.append("documentFiles", file, file.name);
            });

            try {
              const authToken = localStorage.getItem("access_token");
              const response = await axios.post(
                `${fileSystemUrl}/uploadFile/multiple`,
                formData,
                {
                  headers: {
                    "x-drmms-token": authToken,
                    "Content-Type": "multipart/form-data",
                  },
                }
              );

              this.uploadedAttachedFiles = response.data;

              return true;
            } catch (err) {
              console.log(err);
              return {
                error: true,
                errorMessage: "Internal Server Error",
                subtitle: "Unable to upload document",
              };
            }
          } else {
            formData.append("documentFile", this.file, this.file.name);

            try {
              const authToken = localStorage.getItem("access_token");
              const response = await axios.post(
                `${fileSystemUrl}/uploadFile`,
                formData,
                {
                  headers: {
                    "x-drmms-token": authToken,
                    "Content-Type": "multipart/form-data",
                  },
                }
              );

              this.filepath_url = response.data.filepath_url;
              this.date_uploaded = response.data.date_uploaded;
              this.user_uploaded = response.data.user_id;
              this.upload_loader = false;
              this.disable_upload = true;
              this.isUploaded = true;

              return true;
            } catch (err) {
              console.log(err);
              return {
                error: true,
                errorMessage: "Internal Server Error",
                subtitle: "Unable to upload document",
              };
            }
          }
        } else {
          this.no_file_error = true;
          return false;
        }
      },
      async saveOutputDocument() {
        let uploadFile = await this.uploadDocument();

        if (uploadFile.error) {
          Swal.fire({
            icon: "error",
            title: uploadFile.errorMessage,
            text: uploadFile.subtitle,
          });

          return;
        } else if (!uploadFile) return;

        let body = {
          route_id: this.routeId,
          transaction_id: this.document.document.transaction_id,
          document_id: this.document.document.id,
          filepath_url: this.filepath_url,
          date_uploaded: this.date_uploaded,
          route_type: this.routeType,
        };

        if (this.subRouteIndex) body.route_index = this.subRouteIndex;
        try {
          let result;

          if (this.type == "output") {
            if (
              this.routeType == "mainroute" ||
              this.routeType == "secondaryroute"
            ) {
              result = await this.addSubrouteOutputDocument(body);
            } else {
              body = Object.assign(body, {
                route_type: this.routeType,
                route_index: this.subRouteIndex,
                container: this.parentRouteId,
              });

              result = await this.addChildSubrouteOutputDocument(body);
            }
          } else {
            if (this.multiFileInputAccess()) {
              console.log(
                "the uploaded Attached files: ",
                this.uploadedAttachedFiles
              );
              const promises = [];

              this.uploadedAttachedFiles.forEach(file => {
                const payload = {
                  route_id: this.routeId,
                  date_uploaded: file.date_uploaded,
                  filepath_url: file.filepath_url,
                  remarks: this.remarks,
                };

                if (this.routeType == "mainroute")
                  promises.push(this.addInitiatorSupportingDocument(payload));
                else if (this.routeType == "secondaryroute")
                  promises.push(this.addSubrouteSupportingDocument(payload));
                else {
                  promises.push(
                    this.addChildSubrouteSupportingDocument(
                      Object.assign(
                        { ...payload },
                        {
                          route_index: this.subRouteIndex,
                          container: this.parentRouteId,
                        }
                      )
                    )
                  );
                }
              });

              result = await Promise.all(promises);
            } else {
              const payload = {
                route_id: this.routeId,
                date_uploaded: this.date_uploaded,
                filepath_url: this.filepath_url,
                remarks: this.remarks,
              };

              if (this.routeType == "mainroute")
                result = await this.addInitiatorSupportingDocument(payload);
              else if (this.routeType == "secondaryroute")
                result = await this.addSubrouteSupportingDocument(payload);
              else {
                result = await this.addChildSubrouteSupportingDocument(
                  Object.assign(
                    { ...payload },
                    {
                      route_index: this.subRouteIndex,
                      container: this.parentRouteId,
                    }
                  )
                );
              }
            }
          }

          if (result.error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Internal Server Error",
            });
          } else {
            Swal.fire("Saved!", "Output document attached", "success");
            this.close();
          }
        } catch (err) {
          console.log(err);
        }
      },
      close() {
        this.$emit("closeDialog", false);
        this.no_file_error = false;
        this.upload_loader = false;
        this.errorMessage = null;
        this.url = null;
      },
      multiFileInputAccess() {
        return (
          this.type === "supporting" &&
          this.multiFileUploadRoleAccess.includes(this.loggedInPosition)
        );
      },
    },
    computed: mapGetters(["loggedInPosition"]),
  };
</script>

<style scoped>
  img {
    width: 100%;
    border: 1px #bdbdbd dotted;
  }
</style>
